import React, { useCallback } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import { useDropdown } from 'Hooks/Common';

import { scaleOptions } from '../common/scaleOptions';

import ArrowIcon from 'Assets/images/icons/select-arrow-icon.svg';

export interface ScaleDropDownProps {
  rootClassName?: string;
  toggleClassName?: string;
  innerClassName?: string;
  changeScale: (value: number) => void;
  documentScale: number;
}

function ScaleDropDown({
  rootClassName,
  toggleClassName,
  innerClassName,
  changeScale,
  documentScale,
}: ScaleDropDownProps) {
  const [containerRef, isOpen, open, close] = useDropdown();

  const toggleDropdown = useCallback(() => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }, [isOpen, open, close]);

  const onScale = ({ value }) => {
    changeScale(value);
    close();
  };

  const label = scaleOptions.find(item => item.value === documentScale)?.label;

  return (
    <div
      className={classNames('scaleDropDown__wrapper', rootClassName)}
      ref={containerRef}
    >
      <div
        className={classNames(
          'scaleDropDown__select',
          { 'scaleDropDown__select--open': isOpen },
          toggleClassName,
        )}
        onClick={toggleDropdown}
      >
        <div className={classNames('scaleDropDown__select-inner', innerClassName)}>
          <div className="scaleDropDown__select-value-wrapper">
            <div className="scaleDropDown__select-value">{label}</div>
          </div>
        </div>

        <ReactSVG src={ArrowIcon} className="scaleDropDown__select-arrow" />
      </div>
      {isOpen && (
        <div className="scaleDropDown__content-wrapper">
          <div className="scaleDropDown__search-list">
            {scaleOptions
              .filter(item => !(item.value === documentScale))
              .map((item, index) => {
                const { label: optionLabel } = item;
                return (
                  <div
                    key={index}
                    onClick={() => onScale(item)}
                    className="scaleDropDown__search-item"
                  >
                    <p className="scaleDropDown__select-row">{optionLabel}</p>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
}

export default ScaleDropDown;
